// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IApplyAccountMaintenanceFeesToPropertyDto
 */
export interface IApplyAccountMaintenanceFeesToPropertyDto {
    /**
     * 
     * @type {string}
     * @memberof IApplyAccountMaintenanceFeesToPropertyDto
     */
    apply_account_maintenance_fees_to?: IApplyAccountMaintenanceFeesToPropertyDtoApplyAccountMaintenanceFeesToEnum;
    /**
     * 
     * @type {string}
     * @memberof IApplyAccountMaintenanceFeesToPropertyDto
     */
    apply_account_maintenance_fees_to_state?: IApplyAccountMaintenanceFeesToPropertyDtoApplyAccountMaintenanceFeesToStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IApplyAccountMaintenanceFeesToPropertyDtoApplyAccountMaintenanceFeesToEnum {
    ACTIVE_ACCOUNTS_ALL_PLANS = 'ACTIVE_ACCOUNTS_ALL_PLANS',
    ACTIVE_ACCOUNTS_CANCELED_PLANS = 'ACTIVE_ACCOUNTS_CANCELED_PLANS'
}
/**
* @export
* @enum {string}
*/
export enum IApplyAccountMaintenanceFeesToPropertyDtoApplyAccountMaintenanceFeesToStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IApplyAccountMaintenanceFeesToPropertyDto interface.
 */
export function instanceOfIApplyAccountMaintenanceFeesToPropertyDto(value: object): value is IApplyAccountMaintenanceFeesToPropertyDto {
    return true;
}

export function IApplyAccountMaintenanceFeesToPropertyDtoFromJSON(json: any): IApplyAccountMaintenanceFeesToPropertyDto {
    return IApplyAccountMaintenanceFeesToPropertyDtoFromJSONTyped(json, false);
}

export function IApplyAccountMaintenanceFeesToPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IApplyAccountMaintenanceFeesToPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'apply_account_maintenance_fees_to': json['apply_account_maintenance_fees_to'] == null ? undefined : json['apply_account_maintenance_fees_to'],
        'apply_account_maintenance_fees_to_state': json['apply_account_maintenance_fees_to_state'] == null ? undefined : json['apply_account_maintenance_fees_to_state'],
    };
}

export function IApplyAccountMaintenanceFeesToPropertyDtoToJSON(json: any): IApplyAccountMaintenanceFeesToPropertyDto {
    return IApplyAccountMaintenanceFeesToPropertyDtoToJSONTyped(json, false);
}

export function IApplyAccountMaintenanceFeesToPropertyDtoToJSONTyped(value?: IApplyAccountMaintenanceFeesToPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'apply_account_maintenance_fees_to': value['apply_account_maintenance_fees_to'],
        'apply_account_maintenance_fees_to_state': value['apply_account_maintenance_fees_to_state'],
    };
}

